$(function () {
  $('.acc-trigger').on('click', function (e) {
    e.preventDefault(); // リンクのデフォルト動作（#への遷移）を防止
    $(this).next('.acc-content').slideToggle(200); // 0.3秒かけて開閉
  });
});
